import { useMemo } from "react";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { getShippingAgencyTransfers } from "@services/shippingAgencyTransferApi";
import { getVesselCallById } from "@services/vesselCallApi";
import { useQuery } from "@tanstack/react-query";
import { SHIPPING_AGENCY_TRANSFER_STATUS } from "../ShippingAgencyTransfer/flow/utils";

const SERVICE = "bff-vessel-call";

export const useCheckProposedAgency = (vesselCallId: string) => {
  const { user } = useAuthStore();

  const { data: vesselCallDetails } = useQuery({
    queryKey: ["vesselCallDetails", vesselCallId],
    queryFn: () => getVesselCallById(SERVICE, vesselCallId),
  });

  const { data: shippingAgencyAllTransfersData, isError: isTransfersError } = useQuery({
    queryKey: ["getShippingAgencyTransfers", vesselCallId, "pending-transfers"],
    queryFn: () =>
      getShippingAgencyTransfers(SERVICE, {
        vesselCallId,
        pageNumber: 1,
        pageSize: 25,
        statuses: [
          SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_APPROVAL,
          SHIPPING_AGENCY_TRANSFER_STATUS.PENDING_MARINE_DEPARTMENT_APPROVAL,
        ],
      }),
    enabled: !!vesselCallDetails?.vesselId,
  });

  const isProposedAgency = useMemo(() => {
    if (!user || !vesselCallDetails || !shippingAgencyAllTransfersData || isTransfersError)
      return false;
    const pendingTransfers = shippingAgencyAllTransfersData.shippingAgencyTransfers.filter(
      (transfer) =>
        transfer.status === "PENDING_APPROVAL" ||
        transfer.status === "PENDING_MARINE_DEPARTMENT_APPROVAL",
    );
    return pendingTransfers.some(
      (pendingTransfer) => pendingTransfer.newShippingAgency?.companyCode === user.companyId,
    );
  }, [vesselCallDetails, shippingAgencyAllTransfersData, user]);

  return isProposedAgency;
};
